module.exports = __webpack_public_path__ + "static/media/hogsozzle-img.29d595cf.jpg";